export const Vileyka = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [26.653669330156845, 54.42554691942979],
            [26.669778830675284, 54.42346423810642],
            [26.68233358177997, 54.41900030004882],
            [26.69837576349738, 54.414535876336515],
            [26.708838056234242, 54.41047688689116],
            [26.71581291835838, 54.40641749612843],
            [26.72418275182912, 54.40357568296599],
            [26.73185510007579, 54.40357568296599],
            [26.74161990669012, 54.40398166825639],
            [26.746502309548134, 54.40519960001484],
            [26.75487214391717, 54.40763535555169],
            [26.763939464408963, 54.409665040886466],
            [26.768124381144446, 54.410070965898115],
            [26.774401757145824, 54.41169462576033],
            [26.786956508250512, 54.41291232846436],
            [26.798116287109906, 54.41291232846436],
            [26.801603717722855, 54.41331822185185],
            [26.809181207468555, 54.41386893082506],
            [26.813752252452502, 54.415863890192554],
            [26.819466059580748, 54.41819122009588],
            [26.83032229231577, 54.41968729149954],
            [26.836321789755402, 54.41918860727304],
            [26.844321118477296, 54.41686133347304],
            [26.84946354498237, 54.4147001756923],
            [26.86003408740595, 54.410044986834464],
            [26.863462371143896, 54.40671952818201],
            [26.86431944207834, 54.403227506899725],
            [26.86203391958651, 54.40040041422827],
            [26.854320280277705, 54.39624257178798],
            [26.84774940311337, 54.394080326647725],
            [26.840035763804735, 54.392416984012186],
            [26.835750408234105, 54.391086261352825],
            [26.831750743873158, 54.38842468603838],
            [26.83032229231577, 54.38526384175111],
            [26.830036602004327, 54.381270847831956],
            [26.834036266365104, 54.3779430565956],
            [26.839178692870348, 54.37844224247897],
            [26.844892499100297, 54.38010615158544],
            [26.85317751903193, 54.3821027534899],
            [26.86003408740595, 54.383267393086214],
            [26.86917617827214, 54.38360014171025],
            [26.873461532944532, 54.38143723031237],
            [26.882603623810553, 54.37478140451924],
            [26.887746050315798, 54.37345010997126],
            [26.89517399841452, 54.37311727958968],
            [26.904316089280712, 54.37278444650997],
            [26.91174403827779, 54.37245161073258],
            [26.921171819455537, 54.3714530866892],
            [26.928885458764, 54.371286663741785],
            [26.936313406862894, 54.3716195094853],
            [26.941741523679582, 54.37245161073258],
            [26.948312401742214, 54.37411576264111],
            [26.957168801398495, 54.37594625183954],
            [26.964596750395742, 54.376611864041536],
            [26.973738841261763, 54.37677826540602],
            [26.983452312750956, 54.37644546200272],
            [26.988880429567587, 54.376112655901636],
            [26.996594067977924, 54.37528062884604],
            [27.007164610401503, 54.374614995061336],
            [27.01344979815258, 54.374614995061336],
            [27.02059205683821, 54.3742821741223],
            [27.027734314625548, 54.37394935048525],
            [27.031448289573177, 54.37561344169177],
            [27.033448121753793, 54.377610262634676],
            [27.038876238570424, 54.38077169634414],
            [27.04287590293137, 54.38176999324992],
            [27.046304186669317, 54.381270847831956],
            [27.048875400371003, 54.37894142229237],
            [27.049161090682446, 54.376611864041536],
            [27.04716125760376, 54.3709538158235],
            [27.046875567292318, 54.368290935349876],
            [27.050589542240004, 54.36446274162461],
            [27.052589374420393, 54.36363047849369],
            [27.054874896912338, 54.359801850883],
            [27.05344644535495, 54.35397499320294],
            [27.05773180002734, 54.35014546514594],
            [27.060303013729026, 54.3448168326118],
            [27.060303013729026, 54.34248533885585],
            [27.057446109715727, 54.33815507050008],
            [27.056874729092726, 54.336322896798606],
            [27.056874729092726, 54.334324068209355],
            [27.05773180002734, 54.33232514297498],
            [27.059731633106026, 54.330159530982655],
            [27.064302678089973, 54.32816040278175],
            [27.069159414283604, 54.3261611779285],
            [27.072016317398607, 54.323995240817226],
            [27.073444768956165, 54.31932975925156],
            [27.075444601136553, 54.31683017594855],
            [27.078015813939942, 54.31349716268562],
            [27.080872717953184, 54.31116389223996],
            [27.084586692002574, 54.30983053574488],
            [27.08972911850782, 54.3096638631456],
            [27.09715706660654, 54.30949718987148],
            [27.1025851834234, 54.31016387891856],
            [27.109156060587736, 54.31099722504064],
            [27.114584177404367, 54.31099722504064],
            [27.120869365155613, 54.31033054949302],
            [27.124583339205003, 54.30933051592217],
            [27.129154384188723, 54.3084971360513],
            [27.134582501005582, 54.30783042000468],
            [27.140867688756657, 54.307163693158145],
            [27.14601011436355, 54.305496828267565],
            [27.151723921491794, 54.303163104752],
            [27.15743772772157, 54.301162665005165],
            [27.162580154226816, 54.2991621275271],
            [27.169722412014153, 54.297661661018196],
            [27.174864838519397, 54.29632786710533],
            [27.18086433595903, 54.2946605634321],
            [27.186863832500364, 54.29366014913791],
            [27.194006091185997, 54.293326672305625],
            [27.199719897415946, 54.29315993287696],
            [27.211147511672266, 54.29315993287696],
            [27.2177183888366, 54.29382688654135],
            [27.221718054095845, 54.29432709470103],
            [27.22600340876818, 54.29649459370728],
            [27.226860479702623, 54.29849526027374],
            [27.22886031188318, 54.30132937203007],
            [27.23086014406357, 54.304163288173584],
            [27.2345741190112, 54.30633026888847],
            [27.238573783372203, 54.307497057931414],
            [27.248572945172782, 54.306496955511705],
            [27.25114415797617, 54.30483006362073],
            [27.253429681366413, 54.30166278405477],
            [27.254572442612414, 54.29732821659053],
            [27.25228692012047, 54.29366014913791],
            [27.24685880330378, 54.290658760431086],
            [27.24000223492976, 54.28782391416564],
            [27.232859977142425, 54.2841550006234],
            [27.230574453752126, 54.28198685212999],
            [27.229431692506182, 54.279985383493795],
            [27.22828893126018, 54.27448084286573],
            [27.22886031188318, 54.27281265523129],
            [27.23028876344057, 54.26864189018647],
            [27.232288596519425, 54.2644707030754],
            [27.235431189945814, 54.259798472996465],
            [27.23885947368376, 54.254458132590855],
            [27.24000223492976, 54.250619335577426],
            [27.242573448631447, 54.247114034897834],
            [27.24628742268078, 54.244943937903486],
            [27.25057277735334, 54.244443130077855],
            [27.25542951354703, 54.244443130077855],
            [27.260857629465363, 54.244777002637136],
            [27.26457160441305, 54.24544473964983],
            [27.26971403001994, 54.24678018125212],
            [27.276570598394017, 54.24828250190524],
            [27.28485561832565, 54.24961785164322],
            [27.291997877011283, 54.249951682322944],
            [27.298283063864176, 54.2491171005575],
            [27.30342549036942, 54.247948657716165],
            [27.308567915976198, 54.246279395717295],
            [27.31656724559639, 54.24327455484183],
            [27.319138458399777, 54.241271205475925],
            [27.322566743036077, 54.23976863000871],
            [27.328566239577412, 54.2380990375359],
            [27.336279878886046, 54.23859992237101],
            [27.34399351819468, 54.24010254039678],
            [27.34913594380157, 54.242272892580615],
            [27.353992679995258, 54.243915953560474],
            [27.35456406061826, 54.24410925481635],
            [27.36084924747098, 54.24427619278487],
            [27.36742012553384, 54.24394231617248],
            [27.37484807453086, 54.24394231617248],
            [27.379419119514807, 54.244777002637136],
            [27.38399016539705, 54.2469471084126],
            [27.387989829758, 54.248616343392484],
            [27.39570346906646, 54.25112006842602],
            [27.402274346230797, 54.25228842143218],
            [27.402768464442374, 54.252432754431766],
            [27.408559533982043, 54.25412433838454],
            [27.41055936616243, 54.25662772907907],
            [27.4099879855396, 54.260465966853644],
            [27.41055936616243, 54.2644707030754],
            [27.413416269277377, 54.267640843898846],
            [27.419130076405622, 54.26964291216291],
            [27.428843547894644, 54.272645832753994],
            [27.43398597439989, 54.27431402714092],
            [27.435985806580277, 54.27698299823072],
            [27.436557187203277, 54.28031896835205],
            [27.434271664711446, 54.28432177651001],
            [27.434843045334446, 54.288324195239284],
            [27.437128567826278, 54.291492501457924],
            [27.440556851564224, 54.29349341105927],
            [27.443128064367784, 54.29516076198951],
            [27.447984800561414, 54.297995102745745],
            [27.449413252118802, 54.30332980367649],
            [27.45198446492219, 54.30666364093594],
            [27.45626982049305, 54.30833045805207],
            [27.461983626722827, 54.3089971659989],
            [27.465126221047683, 54.3084971360513],
            [27.46969726603146, 54.30533013811845],
            [27.472839859457792, 54.30332980367649],
            [27.47712521502865, 54.30082924892997],
            [27.481696260012598, 54.29882869525062],
            [27.48826713807523, 54.29849526027374],
            [27.49312387337062, 54.29882869525062],
            [27.49683784831825, 54.30082924892997],
            [27.498266299875638, 54.30449667724707],
            [27.494266634616565, 54.307330375882316],
            [27.490552660567232, 54.30949718987148],
            [27.488552828386673, 54.312330543737346],
            [27.488552828386673, 54.315996947942836],
            [27.493695253993565, 54.318496581864736],
            [27.49740922894125, 54.32149594149399],
            [27.49626646769525, 54.32749400529468],
            [27.493695253993565, 54.333324617738356],
            [27.494552325826305, 54.33682258863246],
            [27.496552158006864, 54.34115299681099],
            [27.497123538629864, 54.34498336281973],
            [27.496552158006864, 54.34848034185711],
            [27.495123706449306, 54.352143524037615],
            [27.49255249274762, 54.35414148630434],
            [27.49140973150162, 54.356805284179245],
            [27.49255249274762, 54.3599683203733],
            [27.497123538629864, 54.3622988224073],
            [27.501408893302198, 54.36329756851927],
            [27.506551319807443, 54.36596077328761],
            [27.508265461676274, 54.368290935349876],
            [27.509408222922275, 54.37311727958968],
            [27.507694081053444, 54.3762790592894],
            [27.5042657964172, 54.37844224247897],
            [27.49883768049864, 54.38193637370722],
            [27.48998127994406, 54.38659475322828],
            [27.479982118143596, 54.393581330937366],
            [27.475696763471262, 54.39956887945391],
            [27.46969726603146, 54.40123193266942],
            [27.462840697657384, 54.403560093165424],
            [27.45741258173905, 54.4065532481963],
            [27.45598413018149, 54.410710046099325],
            [27.456555510804435, 54.4140351811468],
            [27.460269484853825, 54.41636261486633],
            [27.463983458903385, 54.42085086443518],
            [27.46484053073607, 54.424341385060245],
            [27.46712605322807, 54.426668234186025],
            [27.470554336966018, 54.42783160894527],
            [27.47455400222526, 54.42833018801696],
            [27.476268144094092, 54.426335835331486],
            [27.476839524717093, 54.42467380061487],
            [27.479982118143596, 54.422679269455955],
            [27.48455316402567, 54.422845484049674],
            [27.488552828386673, 54.424341385060245],
            [27.49140973150162, 54.42733302380691],
            [27.495123706449306, 54.431155355362364],
            [27.498266299875638, 54.43431266424125],
            [27.5031230351712, 54.43663894719401],
            [27.505122868249885, 54.44012812315799],
            [27.503980106105587, 54.44295247701632],
            [27.50112320299064, 54.444613770352646],
            [27.497694919252865, 54.444613770352646],
            [27.49312387337062, 54.44444764405148],
            [27.489695589632618, 54.44444764405148],
            [27.484267472815986, 54.445942756500585],
            [27.481696260012598, 54.44909892627254],
            [27.482267640635598, 54.454414030398254],
            [27.48626730589467, 54.45657309414133],
            [27.490552660567232, 54.458067763872066],
            [27.495123706449306, 54.459064180038354],
            [27.49998044174481, 54.46006057247058],
            [27.50055182236764, 54.46803083508155],
            [27.500266132056254, 54.47566754686909],
            [27.49798060956425, 54.4793193836619],
            [27.49626646769525, 54.48313686389139],
            [27.497123538629864, 54.49010699634857],
            [27.49998044174481, 54.49176637632422],
            [27.5042657964172, 54.49525085556519],
            [27.506265629495886, 54.49773958709221],
            [27.506837010118886, 54.50188713675766],
            [27.506551319807443, 54.506200141377235],
            [27.504551486728587, 54.5078588686153],
            [27.49883768049864, 54.51051269129675],
            [27.493695253993565, 54.513829727757695],
            [27.488552828386673, 54.51598565668553],
            [27.482839021258428, 54.516151492659105],
            [27.47598245378265, 54.51598565668553],
            [27.470268646654404, 54.5158198200387],
            [27.46369776859177, 54.51681482981962],
            [27.455698439870048, 54.51946807125307],
            [27.450841703676247, 54.52228695086245],
            [27.443985136200467, 54.52576882814799],
            [27.441128232187225, 54.5295819715609],
            [27.44084254187578, 54.533560524646305],
            [27.442556683744613, 54.53936188593383],
            [27.448556181184415, 54.543670934938746],
            [27.448556181184415, 54.54764811429368],
            [27.447984800561414, 54.55228766740299],
            [27.447127729626857, 54.55775503464321],
            [27.450841703676247, 54.5609025805137],
            [27.45626982049305, 54.562559085749626],
            [27.462269317034384, 54.56355295658966],
            [27.471125717589018, 54.564049882924735],
            [27.48026780845504, 54.56520935415455],
            [27.48512454464867, 54.56736257090773],
            [27.48940989932123, 54.5691844342802],
            [27.495695087072306, 54.57216549015027],
            [27.502265964236642, 54.573655936070736],
            [27.51226512603722, 54.574815134106814],
            [27.518550313788467, 54.575146327489904],
            [27.5239784297068, 54.575477518181856],
            [27.532263449638435, 54.57613989149149],
            [27.53797725676668, 54.57878927759754],
            [27.5431196823734, 54.58127292015422],
            [27.549690560436034, 54.5832597252068],
            [27.557404199744667, 54.58524643389984],
            [27.56226093504023, 54.5865708521938],
            [27.56883181310286, 54.587895227431716],
            [27.577973903968882, 54.590378315475846],
            [27.57883097490344, 54.5935233423848],
            [27.57883097490344, 54.596502618074794],
            [27.58140218770683, 54.59848868044003],
            [27.587115994835074, 54.60146759289239],
            [27.595686704179798, 54.602295029752554],
            [27.601400511308043, 54.602791483797205],
            [27.607971389370675, 54.60527366321759],
            [27.610256911862677, 54.60874846068515],
            [27.609685531239677, 54.612388406028685],
            [27.607971389370675, 54.616358884772694],
            [27.607685699059118, 54.62181766036139],
            [27.607685699059118, 54.6252910455446],
            [27.61082829248545, 54.629094888495956],
            [27.61339950528901, 54.63107936152403],
            [27.619113312417255, 54.633890531834254],
            [27.62682695172589, 54.63604011919551],
            [27.633969209513225, 54.638354932877235],
            [27.63711180383791, 54.64133092759846],
            [27.6402543972643, 54.64546389275915],
            [27.644825442248248, 54.64827406923342],
            [27.65653874591783, 54.6542243892838],
            [27.664823765849405, 54.660504337533894],
            [27.67110895360048, 54.664139653125744],
            [27.675679998584428, 54.668600732723576],
            [27.68053673477806, 54.671739717413004],
            [27.688821754709693, 54.674052497872594],
            [27.69453556093964, 54.67520883870759],
            [27.700535058379273, 54.6760347762862],
            [27.70567748398622, 54.67653033076914],
            [27.71287966907613, 54.67681751887801],
            [27.71111904920491, 54.68173768714456],
            [27.71111904920491, 54.69530296286149],
            [27.71111904920491, 54.707540903989525],
            [27.715125862568527, 54.71646896407157],
            [27.711691451499348, 54.729361581072226],
            [27.708829442724664, 54.73597158821826],
            [27.700815815997146, 54.74026751563349],
            [27.69222978787451, 54.74125881764036],
            [27.67963694728735, 54.74258051797659],
            [27.67162332055983, 54.74423258156844],
            [27.671050919164713, 54.746875743920555],
            [27.668188909490652, 54.750509809879816],
            [27.659030479972785, 54.753813223001885],
            [27.64758244307535, 54.75546482883891],
            [27.63327239650397, 54.75711636722673],
            [27.61438313427442, 54.7581072582434],
            [27.60350749877216, 54.758437549553264],
            [27.585763041131543, 54.75876783816523],
            [27.576604611613618, 54.75942840819465],
            [27.565728976111416, 54.76273109376501],
            [27.56520351792051, 54.763640560161946],
            [27.56026110285967, 54.76249993473937],
            [27.549976250747648, 54.760027350929136],
            [27.539691398635625, 54.75738976119197],
            [27.534834662441824, 54.75508172964334],
            [27.529977927146433, 54.750959916924614],
            [27.528549475589045, 54.7471674785707],
            [27.5222642878378, 54.74485886424998],
            [27.515407720361907, 54.74370450773847],
            [27.502837344859586, 54.74337468554933],
            [27.494838016137862, 54.74337468554933],
            [27.48569592527167, 54.74386941782603],
            [27.477410905340037, 54.7445290514612],
            [27.470840027277404, 54.74601318786057],
            [27.468840195097016, 54.747991952310656],
            [27.468268814474015, 54.749970619557246],
            [27.46426915011307, 54.751289677342356],
            [27.458555342984823, 54.75079503570856],
            [27.45484136893549, 54.747991952310656],
            [27.453412916479806, 54.74551848177043],
            [27.45141308429919, 54.74189045246021],
            [27.450270323053417, 54.73908675215489],
            [27.4454671542984, 54.73648903345145],
            [27.436271496891834, 54.731499296843026],
            [27.43398597439989, 54.729519726594106],
            [27.433128902566978, 54.726880149853855],
            [27.43512873564589, 54.7247353671566],
            [27.436271496891834, 54.72308545655824],
            [27.439985470941224, 54.72110547580769],
            [27.446556349003856, 54.718135322818],
            [27.449984632741803, 54.71615510027061],
            [27.45198446492219, 54.713679686069895],
            [27.45198446492219, 54.71120412021611],
            [27.450556013364803, 54.7092235591287],
            [27.44684203931547, 54.707407959823115],
            [27.443128064367784, 54.706252535607064],
            [27.435985806580277, 54.706087472391914],
            [27.43227183163259, 54.70691278226923],
            [27.4291292382062, 54.70691278226923],
            [27.422844050455012, 54.70691278226923],
            [27.418273005471065, 54.706582660541244],
            [27.412273508031376, 54.70427173268769],
            [27.4077024630476, 54.70030983611656],
            [27.402560036542354, 54.69783345457864],
            [27.396846230312462, 54.69651265594979],
            [27.388275520069442, 54.694201154364976],
            [27.38056188076081, 54.69288023748902],
            [27.37599083577686, 54.69271511985619],
            [27.371419789894617, 54.69321047073936],
            [27.369705648025786, 54.695191814322584],
            [27.368562886779785, 54.69915421021011],
            [27.367705815845227, 54.70113526355726],
            [27.364563222418838, 54.70394158946277],
            [27.360563557159594, 54.70377651684265],
            [27.355992512175646, 54.70262098969192],
            [27.353992679995258, 54.698824025333124],
            [27.352564227539403, 54.69436626595109],
            [27.35113577598196, 54.69106390657328],
            [27.347993182555626, 54.68891722833797],
            [27.342565066637235, 54.68610986306385],
            [27.335994188574603, 54.682971989201235],
            [27.3282805492658, 54.67983387328013],
            [27.321138290580166, 54.67702587920394],
            [27.311139128779757, 54.671904920385714],
            [27.30399687099242, 54.669261591658255],
            [27.29714030261823, 54.6690963779327],
            [27.285998379571595, 54.669426804711804],
            [27.276570598394017, 54.66959201709318],
            [27.27028541064294, 54.669261591658255],
            [27.264285914101606, 54.66827029922382],
            [27.258286416661804, 54.66711376080394],
            [27.25114415797617, 54.66628764176994],
            [27.243144829254447, 54.664470120230476],
            [27.23885947368376, 54.662487277275545],
            [27.23828809306076, 54.66033908818656],
            [27.238573783372203, 54.65620763553153],
            [27.240287925241148, 54.65389383883189],
            [27.244001900188834, 54.651745194834234],
            [27.246001732369393, 54.648769962469544],
            [27.244001900188834, 54.64546389275915],
            [27.241430687385446, 54.64215755466108],
            [27.238002402749203, 54.63885094712447],
            [27.238002402749203, 54.635378719802134],
            [27.233431357765426, 54.632402289404865],
            [27.22828893126018, 54.63124472986243],
            [27.223717886276233, 54.6302525092259],
            [27.21400441478721, 54.63041788144619],
            [27.20686215610158, 54.63091399251306],
            [27.20229111111763, 54.63157546452214],
            [27.197434374923944, 54.632402289404865],
            [27.19257763962861, 54.6322369257731],
            [27.187149522811808, 54.630583252474366],
            [27.18400692938542, 54.62793723481815],
            [27.180578645647472, 54.6252910455446],
            [27.170579483847007, 54.62247928030348],
            [27.160866012357815, 54.62198306635554],
            [27.154580824606626, 54.62181766036139],
            [27.14458166280616, 54.62065979957299],
            [27.139439236300916, 54.62065979957299],
            [27.133725430071024, 54.62165225369472],
            [27.12686886169695, 54.622810086239724],
            [27.12429764889339, 54.622810086239724],
            [27.120297984532613, 54.62181766036139],
            [27.116012628961755, 54.61983273597849],
            [27.11258434522398, 54.618343978621965],
            [27.11172727428942, 54.618343978621965],
            [27.103442254357788, 54.61900565557198],
            [27.101728112488786, 54.620163563433664],
            [27.1008710415544, 54.622975488199245],
            [27.101156731865842, 54.62628338669498],
            [27.1020138028004, 54.62810261593228],
            [27.103727944669174, 54.63207156146899],
            [27.10572777684979, 54.634551955432414],
            [27.108584679964736, 54.63670150835122],
            [27.106013467161176, 54.63901628386236],
            [27.103727944669174, 54.64066961426295],
            [27.096014305360598, 54.64066961426295],
            [27.09030049913082, 54.64017362220221],
            [27.085729453248575, 54.6411656002731],
            [27.08544376293696, 54.64348012216993],
            [27.088300666051964, 54.64711696096731],
            [27.09144326037682, 54.64943114403985],
            [27.096014305360598, 54.65240632800413],
            [27.098585518164157, 54.655877101212184],
            [27.098871208475543, 54.65984333611158],
            [27.098585518164157, 54.664139653125744],
            [27.096871376295155, 54.66810508146574],
            [27.09030049913082, 54.67273092516763],
            [27.08972911850782, 54.67273092516763],
            [27.080872717953184, 54.67273092516763],
            [27.076015981759554, 54.672565725555216],
            [27.06715958120492, 54.673226519972275],
            [27.060874394352027, 54.67355691314856],
            [27.055160587223952, 54.674382884328566],
            [27.05087523255139, 54.67653033076914],
            [27.048875400371003, 54.67818213588441],
            [27.046875567292318, 54.68082488346215],
            [27.04544711573476, 54.6833023036009],
            [27.04430435448876, 54.6884218250471],
            [27.044590044800373, 54.69172439994901],
            [27.04744694791532, 54.694201154364976],
            [27.051446613174562, 54.69618244957411],
            [27.057446109715727, 54.69783345457864],
            [27.064302678089973, 54.6994843923996],
            [27.065445439335974, 54.702125753693224],
            [27.064874058712974, 54.70410666141123],
            [27.059160252483025, 54.705922408504875],
            [27.052589374420393, 54.70575734394623],
            [27.046875567292318, 54.705427212813504],
            [27.03916192888181, 54.704932011075925],
            [27.033448121753793, 54.707407959823115],
            [27.03059121863879, 54.70955365936061],
            [27.027734314625548, 54.710543943934624],
            [27.022306198707156, 54.710378898184956],
            [27.018592224657823, 54.70938860958057],
            [27.016592391578968, 54.70773807483346],
            [27.014306869087136, 54.705592278715585],
            [27.01144996597219, 54.704601873225386],
            [27.004307707286557, 54.70328129495181],
            [26.998022520433608, 54.70179559300169],
            [26.992308713305363, 54.69981457190181],
            [26.989451810190587, 54.69750325895262],
            [26.986594906177345, 54.6948615971973],
            [26.980881099947396, 54.69304535445019],
            [26.97516729281932, 54.69304535445019],
            [26.968025035031815, 54.69304535445019],
            [26.963739679461128, 54.69321047073936],
            [26.958597253854236, 54.6948615971973],
            [26.956311730464108, 54.69667775812991],
            [26.95488327890655, 54.69783345457864],
            [26.95316913703755, 54.69964948248662],
            [26.94859809205377, 54.70113526355726],
            [26.94431273648297, 54.70146542962311],
            [26.940884452745138, 54.70113526355726],
            [26.936313406862894, 54.6994843923996],
            [26.934313574682506, 54.697998551384046],
            [26.93202805219056, 54.69717306063893],
            [26.93088529094456, 54.69700796047448],
            [26.927171316895, 54.69717306063893],
            [26.925742864439314, 54.69915421021011],
            [26.925742864439314, 54.70113526355726],
            [26.9265999353737, 54.70427173268769],
            [26.927171316895, 54.707407959823115],
            [26.9265999353737, 54.71136916260701],
            [26.924885793504927, 54.71466986988594],
            [26.922600271012925, 54.718630363860996],
            [26.922600271012925, 54.720775469612875],
            [26.922600271012925, 54.7247353671566],
            [26.92145750976698, 54.728199959714686],
            [26.920029058209366, 54.73050952406601],
            [26.915172322015735, 54.73232408902243],
            [26.910886967343345, 54.73331381747664],
            [26.9080300642284, 54.73446847011809],
            [26.906601611772714, 54.73644779860996],
            [26.9051731602151, 54.73958153680667],
            [26.904316089280712, 54.743539596979645],
            [26.902316257100324, 54.74634298856358],
            [26.899745044296765, 54.748156844940695],
            [26.89403123716852, 54.74898129801926],
            [26.8888888115618, 54.74914618662092],
            [26.88346069474511, 54.74964084839695],
            [26.878318269138163, 54.75063015382102],
            [26.87488998450192, 54.75194919012148],
            [26.87231877169853, 54.75425740077219],
            [26.869747558895142, 54.75689519408024],
            [26.866890655780196, 54.75903827459382],
            [26.863462371143896, 54.761675756918805],
            [26.860891158340337, 54.76249993473937],
            [26.856034422146706, 54.76184059382541],
            [26.852891828720317, 54.760851562315395],
            [26.85146337716293, 54.75738976119197],
            [26.85317751903193, 54.754752000108965],
            [26.858319945537005, 54.75161943507476],
            [26.86260530020951, 54.748156844940695],
            [26.865176513012898, 54.7453535783975],
            [26.865176513012898, 54.74090093299935],
            [26.86489082270134, 54.738921822594534],
            [26.86174822927495, 54.73529320185855],
            [26.859748397094563, 54.73364372158903],
            [26.85517735121232, 54.728034985832664],
            [26.85146337716293, 54.725230327084034],
            [26.845463879723127, 54.722260476332394],
            [26.84146421536235, 54.72325045058858],
            [26.83975007349335, 54.72539531238323],
            [26.83889300255879, 54.728859848527065],
            [26.838607312247348, 54.731994174165436],
            [26.83832162193596, 54.73595297568221],
            [26.837464551001403, 54.740076315415024],
            [26.83660748006696, 54.74205536993384],
            [26.834036266365104, 54.74469395819142],
            [26.831750743873158, 54.74584828650205],
            [26.825179865810526, 54.74617808854782],
            [26.818894678957747, 54.74502376963733],
            [26.81632346615436, 54.743539596979645],
            [26.811752420272114, 54.741065854501755],
            [26.80946689778017, 54.73925168104353],
            [26.80632430435361, 54.73677767720426],
            [26.802324639094536, 54.73512825685356],
            [26.799182045667976, 54.73397362301523],
            [26.795468071618586, 54.73397362301523],
            [26.790611335424956, 54.73496331117707],
            [26.787754432309953, 54.737437426334566],
            [26.785754600129565, 54.73908675215489],
            [26.782897696116322, 54.74073601082546],
            [26.780897863935763, 54.74189045246021],
            [26.777183889886373, 54.74304486067422],
            [26.772898534315686, 54.744034327241934],
            [26.76947025057774, 54.744199235986514],
            [26.76147092095772, 54.74337468554933],
            [26.757471256596773, 54.742550118325596],
            [26.753185901026086, 54.740241240274884],
            [26.75032899791114, 54.73793223113137],
            [26.747472094796137, 54.736942615494115],
            [26.74432950047145, 54.73661273824291],
            [26.742043977979506, 54.738427029884804],
            [26.741758287667892, 54.74040616446314],
            [26.74118690704495, 54.7427150331132],
            [26.740901216733505, 54.74469395819142],
            [26.740615526421948, 54.74601318786057],
            [26.740169135590975, 54.747827059009126],
            [26.73838357047049, 54.75220680973956],
            [26.73525883285697, 54.75529811315852],
            [26.73034853012291, 54.75581330762054],
            [26.724545444828493, 54.7560709021339],
            [26.71963514209432, 54.75632849500806],
            [26.712492884307153, 54.75890433567719],
            [26.709814536626254, 54.76044976119914],
            [26.706689799012736, 54.76354043523651],
            [26.701779496278505, 54.764828146604486],
            [26.696422802713528, 54.76405552480412],
            [26.69106610914838, 54.76096489010098],
            [26.68794137063651, 54.75787401887038],
            [26.683477458733478, 54.75220680973956],
            [26.681245503680145, 54.74937290741644],
            [26.679906330288986, 54.7460234942705],
            [26.677227982608088, 54.74421984972673],
            [26.672764071603353, 54.74293148272062],
            [26.66740737803815, 54.74318915919309],
            [26.66338985696609, 54.74318915919309],
            [26.658033163401115, 54.74318915919309],
            [26.655801207449485, 54.74009693125362],
            [26.65446203405827, 54.73623131435522],
            [26.652230079004994, 54.73004555952758],
            [26.649551731324095, 54.725921198315234],
            [26.647766167101906, 54.72128079060309],
            [26.645534211150277, 54.718702556408914],
            [26.641516690976516, 54.716382005742105],
            [26.635267214851126, 54.71560845933601],
            [26.62946412955671, 54.71560845933601],
            [26.620982698378157, 54.71586630960496],
            [26.615626003914713, 54.716897695319915],
            [26.61205487457204, 54.719991694003284],
            [26.609376527789493, 54.72385886030304],
            [26.607144571837864, 54.72643676655133],
            [26.598663140659312, 54.72849897339108],
            [26.59241366453392, 54.72927227383752],
            [26.5817002765055, 54.73262307226844],
            [26.575239438821427, 54.73392869752382],
            [26.56660152284212, 54.72576693689467],
            [26.556763365037455, 54.719051948288836],
            [26.550502720224415, 54.71130250280828],
            [26.552291476270796, 54.70251800690056],
            [26.56302401074953, 54.69424850776244],
            [26.570179033136014, 54.687528298592156],
            [26.57912281336729, 54.676670225050884],
            [26.586277835753606, 54.66477471697971],
            [26.588066591799816, 54.65701489961805],
            [26.591644103892406, 54.64977106558234],
            [26.597010371131887, 54.64304349186375],
            [26.601482260797752, 54.63942049206207],
            [26.610426040129823, 54.63838528964959],
            [26.62652484184798, 54.64045566839451],
            [26.639940511745294, 54.642525940120095],
            [26.6506730462242, 54.64045566839451],
            [26.657828068610513, 54.634761873461684],
            [26.66587747036897, 54.63062043158783],
            [26.682870651459552, 54.63010272246282],
            [26.68555378417983, 54.63372655233866],
            [26.691814429892077, 54.635797168504666],
            [26.703441342843746, 54.63527952413085],
            [26.70433572041719, 54.62958500524388],
            [26.697180698030877, 54.626478567931656],
            [26.68555378417983, 54.61974714061819],
            [26.683765028133564, 54.614050446271165],
            [26.682870651459552, 54.60783496181409],
            [26.682870651459552, 54.599546172218254],
            [26.686448162652766, 54.59125569549411],
            [26.696286319558112, 54.58710982445899],
            [26.701652586797536, 54.58037188425516],
            [26.70433572041719, 54.57415125657536],
            [26.69270880836484, 54.57363282799281],
            [26.682870651459552, 54.57726168867606],
            [26.67124373760845, 54.57415125657536],
            [26.67124373760845, 54.56429998935312],
            [26.68018751694052, 54.554446340726145],
            [26.681081895413115, 54.54718423336567],
            [26.66945498156224, 54.54459031069439],
            [26.657828068610513, 54.54977799146127],
            [26.6453067780854, 54.554446340726145],
            [26.634574243606494, 54.55652099125092],
            [26.625630464274593, 54.55289028335994],
            [26.625630464274593, 54.54718423336567],
            [26.630996731514017, 54.540439690339554],
            [26.63189110998684, 54.53473189925785],
            [26.627419220320803, 54.52746628274281],
            [26.63010235394063, 54.52279484700466],
            [26.638151755699084, 54.51916113807607],
            [26.639940511745294, 54.51396956414408],
            [26.64351802203919, 54.50929658337071],
            [26.653356179843854, 54.5108543035833],
            [26.66140558070316, 54.50773880470217],
            [26.66498309279558, 54.50202644056793],
            [26.662299959175925, 54.49267721268325],
            [26.66856060488817, 54.48488455567775],
            [26.67124373760845, 54.47709041389152],
            [26.66856060488817, 54.46721570044423],
            [26.658722447083335, 54.46305721461886],
            [26.651567423797644, 54.455258912568866],
            [26.640834888419533, 54.45057921745695],
            [26.640834888419533, 54.44485886464486],
            [26.65246180227041, 54.441218224641545],
            [26.657828068610513, 54.43705709570855],
            [26.656933691037125, 54.43029436029656],
            [26.653669330156845, 54.42554691942979],
          ],
        ],
      },
      properties: {
        shapeName: "Vileyka",
        shapeISO: "",
        shapeID: "67162791B71807573158689",
        shapeGroup: "BLR",
        shapeType: "ADM2",
      },
    },
  ],
};
